export default "__VITE_ASSET__CwTinV$P__"